import "./chat.css";

export default function ChatHeader(props) {
  // the header for the individual chat window
  // for user: fixed size, for admin: dynamic size
  // props:
  //     admin (boolean): if true, apply specific css admin class
  //     text (string):   text for header

  return (
    <div>
      <div className={props?.admin ? "chat-header-admin" : "chat-header"}>
        <h6>{props.text}</h6>
      </div>
    </div>
  );
}
